import { Language } from "@/i18n/language";
import { Social } from "./social";
import { UserName } from "./user-name";

export function AccountUser() {
    return (
      <div className="px-4 flex items-center justify-between gap-1 pt-4">
        <UserName />
  
        <div className="min-w-[160px] flex items-center gap-2">
          <Social />
  
          <Language />
        </div>
      </div>
    );
  }
  